module.exports = __webpack_public_path__ + "media/images/pc/stores/yokohama_ekimae/yokohama_ekimae_concept_03-31309c68027623b38dc7b9517e0af067.jpg";